
/**
 * 空间高度测量
 */

import DrawPolyline from "../plot/DrawPolyline"
import ConstantDraw from "../constants/ConstantDraw"
import { getSurfaceHeight } from "./utils/index"
class HeightSpace extends DrawPolyline {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
        this.style = {
            clampToGround: false
        }
    }

    leftClick(evt) {
        if (!this.plot) {
            super.leftClick(evt);

            var cartesian = this.positions[0];
            var label1 = ConstantDraw.Style_Label;
            label1.text = "起点";
            this.startPoint = this.createPoint(cartesian);
            this.startPoint.label = label1;

            var cartesian = this.positions[0];
            var label2 = ConstantDraw.Style_Label;
            label2.text = "终点";
            label2.heightReference = Cesium.HeightReference.NONE;
            this.endPoint = this.createPoint(cartesian);
            this.endPoint.label = label2;

            this.entities.push(this.startPoint);
            this.entities.push(this.endPoint);
            this.entitiesLabel.push(this.startPoint);
            this.entitiesLabel.push(this.endPoint);
        }
    }

    createEllipseTemp(position) {
        var ellipse = this.viewer.entities.add({
            position: position,
            name: "EllipseTemp",
            point: {
                pixelSize: 10,
                color: Cesium.Color.TURQUOISE,
                outlineColor: Cesium.Color.YELLOW,
                outlineWidth: 2,
            },
            ellipse: {
                height: 0,
                semiMinorAxis: 25,
                semiMajorAxis: 25,
                material: Cesium.Color.RED.withAlpha(0.2),
                outline: true
            }
        });
        return ellipse;
    }

    mouseMove(evt) {
        super.mouseMove(evt);
        if (this.plot) {
            var ellipsoid = this.viewer.scene.globe.ellipsoid;
            var start = this.startPoint.position.getValue();
            var end = this.positions[1];
            var carto_start = ellipsoid.cartesianToCartographic(start);
            var carto_end = ellipsoid.cartesianToCartographic(end);
            this.endPoint.position.setValue(end);
            var height = (carto_end.height - carto_start.height).toFixed(2);
            this.startPoint.label.text = `起点(高程${carto_start.height.toFixed(2)}米)`;
            this.endPoint.label.text = `终点(高程${carto_end.height.toFixed(2)}米)\n高度差:${height}米`;
        }
    }


    initEditor() {
    }

    reset() {
        super.reset();
        this.sum = 0;
        this.entitiesLabel = [];
        this.startPoint = null;
        this.endPoint = null;
    }

    initKeyPositions() {
        var arr = [];
        for (let i = 0; i < this.entitiesLabel.length; i++) {
            var pos = this.entitiesLabel[i].position.getValue();
            arr.push(pos);
        }
        this.positions = arr; //
        this.plot.attrPlot = {
            edit_positions: this.positions.slice(),
            entitiesLabel: this.entitiesLabel
        }; //标绘标识
    }

}

export default HeightSpace